/* =========================================================
   Sticky ATC - Change Options
========================================================= */

document.addEventListener(
  'click',
  function (event) {
    const link = event.target.closest('.change-options-link');

    if (!link) return;

    event.preventDefault();

    const variantPicker = document.querySelector(
      'variant-picker[ref="mainVariantPicker"]'
    );

    if (!variantPicker) return;

    variantPicker.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  },
  true
);
